import type { ReactNode } from 'react';
import AccessRestrictedPage from '../../../components/AccessRestrictedPage';
import { useAuth } from '../../../context/AuthContext';

interface ClientDepartmentRouteGuardProps {
  children: ReactNode;
}

const ClientDepartmentRouteGuard = ({
  children,
}: ClientDepartmentRouteGuardProps) => {
  const { user, logout } = useAuth();

  const hasDepartmentBinding = Boolean(
    (user as { managedDepartamentId?: number | null; departamentId?: number | null })
      ?.managedDepartamentId ??
      (user as { managedDepartamentId?: number | null; departamentId?: number | null })
        ?.departamentId,
  );

  if (!hasDepartmentBinding) {
    return (
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="mx-auto flex min-h-[calc(100vh-3rem)] max-w-3xl items-center justify-center">
          <div className="w-full">
            <AccessRestrictedPage
              title="Departamento não vinculado"
              message="Seu perfil CLIENT ainda não possui um departamento vinculado. O acesso às páginas do cliente permanece bloqueado até que esse vínculo seja definido pelo backend ou pelo administrador."
            />

            <div className="mt-4 flex justify-center">
              <button
                type="button"
                onClick={logout}
                className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700"
              >
                Sair e voltar ao login
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ClientDepartmentRouteGuard;
